export enum ElementSelectors {
  AppBlock = '.App',
  AppContent = '.App__content',
  AppFooter = '.App__footer',
}
